const translations = {
    deleteFailed: 'Delete Failed',
    saveFailed: 'Save Failed'
};

export default translations;
